import { Dataset, User, UserDatasetsRequest, UserStatusEnum } from '~/api/types';
import { v2Api } from '../v2Api';

const tags = ['user'] as const;

const userApi = v2Api
  .enhanceEndpoints({
    addTagTypes: tags,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getUser: builder.query<User, object>({
        query: () => 'users/me',
        transformResponse: (response: { data: User }) => response.data,
        providesTags: tags,
      }),
      clearCrossRegionAccess: builder.mutation<void, void>({
        query: () => ({
          url: 'users/me/cross-region-access',
          method: 'DELETE',
        }),
      }),
      getUsers: builder.query<User[], object>({
        query: () => {
          const deleted = false;
          const status = UserStatusEnum.ACTIVE;

          return `users?deleted=${deleted}&status=${status}`;
        },
        transformResponse: (response: { data: User[] }) => response.data,
        providesTags: tags,
      }),
      getUserDatasets: builder.query<Dataset[], UserDatasetsRequest>({
        query: ({ userId, destinationType = false }) => `users/${userId}/datasets?destination_type=${destinationType}`,
        transformResponse: (response: { data: Dataset[] }) => response.data,
        providesTags: tags,
      }),
    }),
  });

export default userApi;
